import React from 'react';

import { Image, Text } from '@cashfree-intl/coherent';

import lockIcon from 'images/lock.svg';

import { StyledViewAuth } from './styled';
import { IWithReadPermissionsProps } from './types';

const WithReadPermissions = ({
  description,
  merchantEmail,
}: IWithReadPermissionsProps) => (
  <StyledViewAuth>
    <Image inline src={lockIcon} />
    <Text className="mb-3" variant="h16">
      You do not have the permission {description}.
    </Text>
    <Text color="bodyLight">
      Contact <a href={`mailto:${merchantEmail}`}>{merchantEmail}</a> to get the
      required access.
    </Text>
  </StyledViewAuth>
);

export default WithReadPermissions;
